import Button from "@/common/components/Button";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useMaintenanceFiscalAssessmentDocumentApprove } from "../hooks/fiscalAssessmentDocuments/useMaintenanceFiscalAssessmentDocumentApprove";

interface FiscalAssessmentDocumentGroupDocumentApproveProps {
  documentId: string;
}

const FiscalAssessmentDocumentGroupDocumentApprove = ({
  documentId,
}: FiscalAssessmentDocumentGroupDocumentApproveProps) => {
  const { forwardingId } = useParams();

  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: approve,
    isPending: approveIsPending,
  } = useMaintenanceFiscalAssessmentDocumentApprove({
    documentId,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwardingId],
        });
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    }
  });

  return (
    <>
      <Button
        variant="success"
        onClick={() => approve()}
        isLoading={approveIsPending}
        operationKlassToCheckPermission="Admin::Maintenance::FiscalAssessmentDocuments::Review"
        className="w-[120px]"
        hideContentOnLoading
      >
        Aprovar
      </Button>

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default FiscalAssessmentDocumentGroupDocumentApprove;
